import store from "@/store";

export default async function({ to, next }) {
  if (store.getters["acl/GetCan"](to.meta.permission)) {
    next();
  } else {
    next({ name: "ErrorPage" });
  }
}
